import React from 'react';

const BotonConsultar = (props) => (
  <div className='cotenedorConsulta'>
    <a className='link' href={props.url}>
      <div className='contenedor'>
        <div className='icono'>
          <img className='img' src='https://res.mundigea.com.ar/img/recursos/msg-ico.png' alt='' />
        </div>
        <div className='texto1'>Tenes dudas?</div>
        <div className='texto2'>Consulta aqui</div>
      </div>
    </a>
  </div>
);
export default BotonConsultar;
